import { render, staticRenderFns } from "./update-mobile.vue?vue&type=template&id=2d9f4c58&scoped=true&"
import script from "./update-mobile.vue?vue&type=script&lang=js&"
export * from "./update-mobile.vue?vue&type=script&lang=js&"
import style0 from "./update-mobile.vue?vue&type=style&index=0&id=2d9f4c58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9f4c58",
  null
  
)

export default component.exports